<template>
    <div>
        <!-- Slot Search -->
        <div class="mb-1 ml-2 mr-2">
            <slot></slot>
        </div>
        <!--  -->
        <div v-if="loadingApp == false ">
            <div v-if="data.data.length > 0">
                <div v-for="(dataItem, date) in groupByDate" :key="date">
                    <!-- item -->
                    <div class="listview-title" style="background-color:#F3F4F5;padding: 2px 16px;font-weight:normal;">{{date}}</div>
                    <ul class="listview image-listview-product full ml-0 mr-0">
                        <li v-for="item in dataItem" :key="item.id">
                            <router-link :to="{name:'transaction.prabayar.show', params:{id:item.id}}" class="item pl-2 pr-3 pt-2 pb-2" >
                                <div class="imageWrapper mr-1">
                                    <img v-if="item.product_vendor != null &&
                                        item.product_vendor.prabayar_product != null &&
                                        item.product_vendor.prabayar_product.prabayar_operator != null &&
                                        item.product_vendor.prabayar_product.prabayar_operator.prabayar_category != null" 
                                        v-lazyload :src="require('@/assets/Loader-2.png')" :data-src="VUE_ENV.VUE_APP_ASSET_URL+'/img/icon/'+item.product_vendor.prabayar_product.prabayar_operator.prabayar_category.icon" alt="image" class="imaged w36">
                                    <img v-else v-lazyload :src="require('@/assets/Loader-2.png')" :data-src="require('@/assets/other.png')" alt="image" class="imaged w36">
                                </div>
                                <div class="in">
                                    <div style="width: 90%;">
                                        <!-- <small>{{ item.created_at }}</small> -->
                                        <h4>{{item.product_name}}</h4>
                                        <footer>{{ item.destination }}</footer>
                                    </div>
                                    <span class="text-muted text-right">
                                        <!-- <small>ID#{{ item.id }}</small> -->
                                        <h5 class="mb-0" style="font-weight:normal;">Rp {{ item.price | rupiah }}</h5>
                                        <strong class="text-success" style="font-weight:bold;" v-if="item.status == 'SUCCESS'">Berhasil</strong>
                                        <strong class="text-warning" style="font-weight:bold;" v-if="item.status == 'PENDING' || item.status == 'ONPROCESS'">Dalam proses</strong>
                                        <strong class="text-info" style="font-weight:bold;" v-if="item.status == 'HOLDON'">Dalam pengecekan</strong>
                                        <strong class="text-danger" style="font-weight:bold;" v-if="item.status == 'FAILED'">Gagal</strong>
                                    </span>
                                </div>
                            </router-link>
                        </li>
                    </ul>
                    <!-- * item -->
                </div>
                <div class="m-2 text-center" v-if="data.next_page_url">
                    <ButtonLoader :loading="loadingButton" :styled="'btn btn-primary rounded mr-1 mb-1'" @click.native="$emit('paginate')">Lihat lebih banyak</ButtonLoader>
                </div>
            </div>
            <div class="text-center mt-5 mb-5" v-else>
                <img :src="require('@/assets/image/404.svg')" alt="404" class="w-75 mb-3"><br>
                <i>Transaksi belum tersedia</i>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import moment from 'moment'
moment.locale('id')
export default {
    props:['data','loadingButton','loadingApp'],
    computed:{
        ...mapState(['VUE_ENV']),
        groupByDate(){
            return this.groupBy(this.data.data, 'created_at')
        }
    }, 
    methods: {
        groupBy(array, key){
            const result = {}
            array.forEach(item => {
                let date = moment(item[key]).format('ll');
                if (!result[date]){
                result[date] = []
                }
                result[date].push(item)
            })
            return result
        }
    }
}
</script>